import { useParams, Navigate } from "react-router-dom";
import { ALL_LOCATIONS, LocationContext } from "@/lib/locations";
import { WaitlistPopup } from "@/components/WaitlistPopup";
import RussianBlogPage from "./RussianBlogPage";

const RegionBlogPageRu = () => {
  const { region } = useParams<{ region: string }>();

  const locationData = ALL_LOCATIONS.find(loc => loc.slug === region || loc.regionSlug === region);

  if (!locationData) return <Navigate to="/ru/blog" replace />;

  return (
    <LocationContext.Provider value={locationData}>
      <WaitlistPopup />
      <RussianBlogPage />
    </LocationContext.Provider>
  );
};

export default RegionBlogPageRu;